import {useStaticQuery, graphql} from "gatsby";

const useSuperMainNavBar = () => {
  const {contentfulSuperMainNavBars} = useStaticQuery(
    graphql`
      query SuperMainNavBarsQuery {
        contentfulSuperMainNavBars {
          newNavIsRenderedIn
        }
      }
    `
  );
  return contentfulSuperMainNavBars;
};

export default useSuperMainNavBar;
